'use client'

import { useCallback } from 'react'
import { useRouter } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { ScrollArea } from '@/components/ui/scroll-area'
import LoginForm from './login-form'
import { useLoginDialogStore } from '@/store'

const LoginDialog = () => {
  const t = useTranslations()
  const router = useRouter()
  const { isOpen, close } = useLoginDialogStore()

  const handleLoginSuccess = useCallback(() => {
    close()
    router.refresh()
  }, [close, router])

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="sm:max-w-90">
        <DialogHeader>
          <DialogTitle className="uppercase">{t('login')}</DialogTitle>
          <DialogDescription>{t('you_need_to_login')}</DialogDescription>
        </DialogHeader>
        <ScrollArea className="min-h-0 flex-1" viewportClassName="max-h-[calc(90vh-5rem)]">
          <div className="px-5 pr-3 pb-5">
            <LoginForm idPrefix="dialog" onLoginSuccess={handleLoginSuccess} onNavigate={close} noHeader />
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}

export default LoginDialog
